import { z } from 'zod';
import { DocumentSourceSchema, DocTypeSchema } from '../enums.js';
import { IdSchema, IsoDateTimeSchema } from './common.js';
import { PrdContentSchema } from './prd.js';
import { TddContentSchema } from './tdd.js';
/** projects/{id}/documents/{docType} — a pointer, never the content itself. */
export const DocumentPointerSchema = z.object({
    docType: DocTypeSchema,
    currentVersionId: IdSchema.nullable().default(null),
    currentVersionNumber: z.number().int().nonnegative().default(0),
    status: z.enum(['none', 'draft', 'accepted']).default('none'),
    /** PRD only: the next user story number to hand out. Never decreases, so a deleted story's
     * id is never reused. Absent on PRDs saved before it existed — see assignPrdStoryIds. */
    nextStoryNumber: z.number().int().positive().optional(),
});
/** projects/{id}/documents/{docType}/versions/{versionId} — immutable once written. */
export const DocumentVersionSchema = z.object({
    id: IdSchema,
    versionNumber: z.number().int().positive(),
    parentVersionId: IdSchema.nullable(),
    content: z.union([PrdContentSchema, TddContentSchema]),
    authorUid: IdSchema,
    source: DocumentSourceSchema,
    llmRunId: IdSchema.nullable().default(null),
    changeSummary: z.string().max(500).optional(),
    createdAt: IsoDateTimeSchema,
    acceptedAt: IsoDateTimeSchema.nullable().default(null),
    acceptedByUid: IdSchema.nullable().default(null),
});
//# sourceMappingURL=document.js.map